import { Injectable } from '@angular/core';
import { ITreeOptions } from 'angular-tree-component';

export interface NzTreeOptions extends ITreeOptions {}
